/** A message's markdown cut into its top-level blocks — paragraphs, lists, tables, headings, fenced code — so each
 *  one is parsed and rendered on its own and a block that did not change is not parsed again
 *  (`MessageBubble`'s `Markdown`). Parsing the whole message on every frame of the reveal, and on every card update
 *  of a running batch, starved the pane: the turn's clock stopped and the list stopped following.
 *
 *  A block ends at a blank line, except inside a fenced code block and before an indented line (the continuation of
 *  a list item, which belongs with it). */
export function markdownBlocks(md: string): string[] {
  const lines = md.split('\n');
  const blocks: string[] = [];
  let current: string[] = [];
  let fence: string | null = null;
  const close = () => {
    if (current.some((l) => l.trim())) blocks.push(current.join('\n'));
    current = [];
  };
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const marker = /^\s{0,3}(`{3,}|~{3,})/.exec(line)?.[1] ?? null;
    if (fence) {
      current.push(line);
      if (marker && marker[0] === fence[0] && marker.length >= fence.length) fence = null;
      continue;
    }
    if (marker) fence = marker;
    if (line.trim() === '') {
      const next = lines.slice(i + 1).find((l) => l.trim() !== '');
      if (next !== undefined && /^\s/.test(next)) {
        current.push(line);
        continue;
      }
      close();
      continue;
    }
    current.push(line);
  }
  close();
  return blocks;
}
